module.exports = __webpack_public_path__ + "static/img/1.29e5815.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/1.png
// module id = D46a
// module chunks = 0